import React, { useEffect } from 'react';
import FramePlayer from '../utils/FramePlayer';
import anime from 'animejs';
import lang from '../lang.json';

const Module1 = (props) => {

    const langue = props.langue;
    const texts = lang.lang[`lang_${langue}`].module1;

    useEffect(() => {
        var tl = anime.timeline({
            //complete: callback
        })
        tl
            .add({
                targets: ['#image1', '.t1'],
                opacity: 1,
                duration: 300,
                easing: 'easeInSine',
            }, 3550)
            .add({
                targets: ['#image3', '#arrow2', '.t3', '.t1-2'],
                opacity: 1,
                duration: 300,
                easing: 'easeInSine',
            }, 4870)
            .add({
                targets: ['#image2', '#arrow1', '.t2', '.t1-3'],
                opacity: 1,
                duration: 300,
                easing: 'easeInSine',
            }, 8900)
            .add({
                targets: ['.bulle', '.t4', '.t5', '.t1-4'],
                opacity: 1,
                duration: 600,
                easing: 'easeInSine',
            }, 14500);

        //play a mp3 file
        var audio = new Audio(process.env.PUBLIC_URL + "/assets/sounds/module1.mp3");
        audio.play();
        props.audio.push(audio)

        //sous titres
        let tl2 = anime.timeline({})
        //dabord opacity 0 pour tous
        tl2.add({
            targets: '.st',
            opacity: 0,
            duration: 1,
        })
            .add({
                targets: '.st1',
                opacity: 1,
                duration: 1,
            }, 500)
            .add({
                targets: '.st1',
                opacity: 0,
                duration: 1,
            }, 5000)
            .add({
                targets: '.st2',
                opacity: 1,
                duration: 1,
            }, 5000)
            .add({
                targets: '.st2',
                opacity: 0,
                duration: 1,
            }, 9000)
            .add({
                targets: '.st3',
                opacity: 1,
                duration: 1,
            }, 9000)
            .add({
                targets: '.st3',
                opacity: 0,
                duration: 1,
            }, 14500)
            .add({
                targets: '.st4',
                opacity: 1,
                duration: 1,
            }, 14500)
            .add({
                targets: '.st4',
                opacity: 0,
                duration: 1,
            }, 19000)
    }, []);

    return (
        <>
            <div className="background" />
            <div className="bulle" style={{ opacity: 0 }}>
                <FramePlayer
                    dirName="module1"
                    frameNumber={8}
                    fps={6}
                    initialDelay={200}
                    loop={true}
                    style={{ zIndex: 3, left: '200px' }} />
            </div>
            <img
                src={process.env.PUBLIC_URL + "/assets/images/module1/1.jpg"}
                alt="image1"
                id="image1"
                style={{ position: 'absolute', top: '218px', left: '0px', opacity: 0 }}
            />
            <img
                src={process.env.PUBLIC_URL + "/assets/images/module1/2.jpg"}
                alt="image2"
                id="image2"
                style={{ position: 'absolute', top: '218px', left: '0px', opacity: 0 }}
            />
            <img
                src={process.env.PUBLIC_URL + "/assets/images/module1/3.jpg"}
                alt="image3"
                id="image3"
                style={{ position: 'absolute', top: '0px', left: '280px', opacity: 0 }}
            />
            <svg style={{ position: 'absolute', top: '0px', left: '0px', width: '660px', height: '500px', opacity: 0 }}
                id="arrow1">
                <defs>
                    <marker
                        id='head'
                        orient="auto"
                        markerWidth='3'
                        markerHeight='4'
                        refX='0.1'
                        refY='2'
                    >
                        <path d='M0,0 V4 L2,2 Z' fill="red" />
                    </marker>
                </defs>

                <path
                    id='arrow-line'
                    markerEnd='url(#head)'
                    strokeWidth='2.5'
                    fill='none' stroke='red'
                    d='M 161 300 315 378'
                    style={{ position: 'absolute', zIndex: 2 }}
                />
            </svg>

            <svg style={{ position: 'absolute', top: '0px', left: '0px', width: '660px', height: '500px', opacity: 0 }}
                id="arrow2">
                <defs>
                    <marker
                        id='head'
                        orient="auto"
                        markerWidth='3'
                        markerHeight='4'
                        refX='0.1'
                        refY='2'
                    >
                        <path d='M0,0 V4 L2,2 Z' fill="red" />
                    </marker>
                </defs>

                <path
                    id='arrow-line'
                    markerEnd='url(#head)'
                    strokeWidth='2.5'
                    fill='none' stroke='red'
                    d='M 520 257 360 382'
                    style={{ position: 'absolute', zIndex: 2 }}
                />
            </svg>

            {/* sous titres */}
            <p
                className="st1 st"
                style={{
                    position: 'absolute',
                    top: '452px',
                    left: '10px',
                    opacity: 1,
                    color: 'white',
                    backgroundColor: 'black',
                    backgroundOpacity: 0.5,
                    padding: '5px',
                }}
            >
                {texts.lang30}
            </p>
            <p
                className="st2 st"
                style={{
                    position: 'absolute',
                    top: '452px',
                    left: '10px',
                    opacity: 1,
                    color: 'white',
                    backgroundColor: 'black',
                    backgroundOpacity: 0.5,
                    padding: '5px',
                    zIndex: 18,
                }}
            >
                {texts.lang34}
            </p>
            <p
                className="st3 st"
                style={{
                    position: 'absolute',
                    top: '452px',
                    left: '10px',
                    opacity: 1,
                    color: 'white',
                    backgroundColor: 'black',
                    backgroundOpacity: 0.5,
                    padding: '5px',
                }}
            >
                {texts.lang35}
            </p>
            <p
                className="st4 st"
                style={{
                    position: 'absolute',
                    top: '452px',
                    left: '10px',
                    opacity: 1,
                    color: 'white',
                    backgroundColor: 'black',
                    backgroundOpacity: 0.5,
                    padding: '5px',
                }}
            >
                {texts.lang38}
            </p>

            {/* textes */}
            <p
                style={{
                    position: 'absolute',
                    left: 10,
                    top: 0,
                    color: 'white',
                    fontSize: '15px',
                    zIndex: 15
                }}
            >{texts.lang1}</p>
            <p
                className="t1 text"
                style={{
                    position: 'absolute',
                    top: '130px',
                    left: '20px',
                    opacity: 0,
                    color: 'white',
                    fontSize: '14px',
                    padding: '5px',
                }}
            >
                {texts.lang31}
            </p>
            <p
                className="t1-2 text"
                style={{
                    position: 'absolute',
                    top: '152px',
                    left: '20px',
                    opacity: 0,
                    color: 'white',
                    padding: '5px',
                    fontSize: '12px',
                }}
            >
                {langue === 'fr' &&
                    <><span style={{ fontSize: "14px" }}>capte</span> le jeu d'un improvisateur humain,</>
                }
                {langue === 'en' &&
                    <><span style={{ fontSize: "14px" }}>captures</span> what is played by a human improviser,</>
                }
                {langue === 'es' &&
                    <><span style={{ fontSize: "14px" }}>capta</span> el registro de un improvisador humano,</>
                }
                {langue === 'de' &&
                    <><span style={{ fontSize: "14px" }}>erfasst</span> das Spiel des menschlichen Improvisators,</>
                }
                {langue === 'oc' &&
                    <><span style={{ fontSize: "14px" }}>capta</span> lo jòc d'un improvisaire uman,</>
                }
            </p>
            <p
                className="t1-3 text"
                style={{
                    position: 'absolute',
                    top: '170px',
                    left: '20px',
                    opacity: 0,
                    color: 'white',
                    padding: '5px',
                    fontSize: '12px',
                    zIndex: 5
                }}
            >
                {langue === 'fr' &&
                    <>sous le <span style={{ fontSize: "14px" }}>contrôle</span> d'opérateurs informaticiens,</>
                }
                {langue === 'en' &&
                    <>under the <span style={{ fontSize: "14px" }}>control</span> of computer operators,</>
                }
                {langue === 'es' &&
                    <>bajo el <span style={{ fontSize: "14px" }}>control</span> de operadores informáticos,</>
                }
                {langue === 'de' &&
                    <>unter der <span style={{ fontSize: "14px" }}>Kontrolle</span> von Informatikern,</>
                }
                {langue === 'oc' &&
                    <>sota lo <span style={{ fontSize: "14px" }}>contròtle</span> d'operators informatics,</>
                }
            </p>
            <p
                className="t1-4 text"
                style={{
                    position: 'absolute',
                    top: '360px',
                    left: '420px',
                    width: '200px',
                    opacity: 0,
                    color: 'white',
                    padding: '5px',
                    fontSize: '12px',
                }}
            >
                {langue === 'fr' &&
                    <>pour produire une nouvelle improvisation combinant <span style={{ fontSize: "14px" }}>imitation</span> et <span style={{ fontSize: "14px" }}>transformation</span>.</>
                }
                {langue === 'en' &&
                    <>to produce a new improvisation combining <span style={{ fontSize: "14px" }}>imitation</span> and <span style={{ fontSize: "14px" }}>transformation</span>.</>
                }
                {langue === 'es' &&
                    <>para producir una nueva improvisación que combina <span style={{ fontSize: "14px" }}>imitación</span> y <span style={{ fontSize: "14px" }}>transformación</span>.</>
                }
                {langue === 'de' &&
                    <>um eine neue Improvisation zu Schaffen, in welcher er <span style={{ fontSize: "14px" }}>Imitation</span> und <span style={{ fontSize: "14px" }}>Transformation</span> kombiniert.</>
                }
                {langue === 'oc' &&
                    <>per produsir ua novèra improvisacion combina <span style={{ fontSize: "14px" }}>imitacion</span> e <span style={{ fontSize: "14px" }}>transformacion</span>.</>
                }
            </p>
            <p
                className="t2 text"
                style={{
                    position: 'absolute',
                    top: '342px',
                    left: '169px',
                    opacity: 0,
                    color: 'red',
                    padding: '5px',
                }}
            >
                {texts.lang37}
            </p>
            <p
                className="t3 text"
                style={{
                    position: 'absolute',
                    top: '322px',
                    left: '419px',
                    opacity: 0,
                    color: 'red',
                    padding: '5px',
                }}
            >
                {texts.lang33}
            </p>
            <p
                className="t4 text"
                style={{
                    position: 'absolute',
                    top: '2px',
                    left: '288px',
                    opacity: 0,
                    color: 'red',
                    padding: '5px',
                }}
            >
                {texts.lang40}
            </p>
            <p
                className="t5 text"
                style={{
                    position: 'absolute',
                    top: '53px',
                    left: '261px',
                    opacity: 0,
                    color: 'red',
                    padding: '5px',
                }}
            >
                {texts.lang41}
            </p>
        </>

    );
}

export default Module1;
